import { InjectionToken } from "@angular/core";

export const ACCESS_TOKEN_TIME_SHIFT = new InjectionToken<number>('ACCESS_TOKEN_TIME_SHIFT');
export const REFRESH_TOKEN_TIME_SHIFT = new InjectionToken<number>('REFRESH_TOKEN_TIME_SHIFT');
export const USER_ACTIVITY_TIME_SHIFT = new InjectionToken<number>('USER_ACTIVITY_TIME_SHIFT');
export const COUNTER_START_VALUE = new InjectionToken<number>('COUNTER_START_VALUE');
